import { Model, tProp, types } from "mobx-keystone";
import { nsModel } from "../../lib/namespace";

const addressNS = nsModel("address");

@addressNS.model
export class AddressModel extends Model({
  street1: tProp(types.string),
  street2: tProp(types.maybeNull(types.string)),
  city: tProp(types.string),
  state: tProp(types.string),
  zip: tProp(types.string),
  country: tProp(types.string),
  countryCodeId: tProp(types.maybeNull(types.string)),
}) {}
